import { fetchArticleList } from "@Services/kindsum";
import { IArticleList, IKindsPcInfo } from "@Types/kindsum";
import React, {  } from "react";
import { fetchPaging } from "@Services/api";
import { useQuery } from "react-query";
import { formatThousend } from "../../utils/helper";
import { EyesIcon, LikeIcon } from "@t8891/icon";
import { useSetState } from "ahooks";

type ItemProps = {
  item: IArticleList["items"][0];
};
const Item: React.FC<ItemProps> = ({ item }) => {
  const { link, slug, startTime, thumb, title, type, views, author, description, likes } = item;

  return (
    <div
      id={type === 3 ? "ArticleMovieItem" : "ArticleBottomItem"}
      className={`w-282 cursor-pointer rounded-4 h-400 border-1 border-solid border-[#E8E8E8]`}
      onClick={() => {
        window.open(link, "_blank");
      }}
    >
      <div className='relative'>
        <img className={`object-cover h-186 w-280 rounded-tl-4 rounded-tr-4`} src={thumb} alt='' />
        {type === 3 && (
          <img
            className='absolute top-0 left-0 right-0 bottom-0 m-auto w-56 h-56'
            src='https://photo.8891.com.tw/2024/06/18/1718698565058625.png'
            alt=''
          />
        )}
      </div>
      <div className='px-8 py-14'>
        <p className='text-16 text-[#333] font-medium whitespace-normal line-clamp-2 h-42 leading-20'>{title}</p>
        <div className='text-14 text-[#666] my-14 h-72 line-clamp-3 leading-24'>{description}</div>

        <div className='flex justify-between items-center mb-14 text-[#666] text-12'>
          <div className='flex justify-between w-130 items-center'>
            <div className='flex gap-4 items-center'>
              <EyesIcon size={40} fill={"#999"} /> {!!views ? formatThousend(views) : ""}
            </div>
            <div className='flex gap-4 items-center'>
              <LikeIcon size={32} fill={"#999"} /> {!!likes ? likes : ""}
            </div>
          </div>
          <div className='flex gap-4 items-center'>{slug}</div>
        </div>
        <div className='flex justify-between items-center text-[#999] text-12'>
          <span>{author}</span>
          <span>{startTime.slice(0, 10)}</span>
        </div>
      </div>
    </div>
  );
};

interface IArticleDescList {
  articleId: any[];
  data: IKindsPcInfo;
}

const ArticleDescList: React.FC<IArticleDescList> = ({ articleId, data }) => {
  const { kindId, brandName, kindName } = data;
  const [params, setParams] = useSetState<IArticleList>({
    items: [],
    paging: "",
    total: 0,
  });
  const { items, paging } = params;

  useQuery<IArticleList>(
    [`fetchArticleListId`, kindId],
    async () => {
      const res = await fetchArticleList({
        kindIds: kindId,
        type: "1,2,3",
        from: "pc综述頁",
        // filterIds: `${articleId}`,
        limit: 6,
      });

      setParams(res.data);
      return res.data;
    },
    {
      enabled: articleId.length !== 0,
    },
  );

  if (!items?.length) {
    return null;
  }

  return (
    <div id={"ArticleBottomList"} className='relative mt-40'>
      <div className='text-20 text-black font-[600]'>{`${brandName} ${kindName} 更多資訊`}</div>
      <div className='flex gap-20 flex-wrap my-24'>
        {items.length > 0 && items.map((item, index: number) => <Item key={index} item={item} />)}
      </div>
      {!!paging && (
        <div
          className='text-14 text-[#666] flex justify-center items-center bg-[#f4f4f4] w-140 h-34 mx-auto mb-20 cursor-pointer'
          onClick={async () => {
            const res = await fetchPaging(paging);

            if (res.status === 12000) {
              setParams({
                items: items.concat(res.data.items),
                paging: res.data.paging,
                total: res.data.total,
              });
            }
          }}
        >
          查看更多
        </div>
      )}
    </div>
  );
};

export default ArticleDescList;
